import { Api } from '../../utils/api/api';
import { setData, setError, startFetching } from '../actions';
import { priceDetailsActionTypes as ACTION } from '../actionTypes';
import CONSTANTS from '../../constants/api.constants';

export const getPriceDetails = (arg = {}) => {
  return async (dispatch, getState) => {
    const { force = false } = arg;
    const priceDetailsState = getState().priceDetails;
    if (!force && (priceDetailsState.loaded || priceDetailsState.loading)) {
      return;
    }

    try {
      dispatch(startFetching(ACTION.PRICE_DETAILS_REQUEST));
      const data = await Api.get(`${CONSTANTS.baseUrl}${CONSTANTS.priceDetails}`);
      if (data.status === 200) {
        dispatch(
          setData(ACTION.PRICE_DETAILS_SUCCESS, {
            message: data.data.message,
            priceDetails: data.data.payload,
          })
        );
      }
    } catch (error) {
      if (error && error.response && error.response.status === 400)
        dispatch(setError(ACTION.PRICE_DETAILS_FAILURE, error.response.data.message));
      else {
        dispatch(setError(ACTION.PRICE_DETAILS_FAILURE, 'Something Went Wrong!'));
      }
    }
  };
};
